import { INBOX_TYPES, getInboxIconByType } from 'dashboard/helper/inbox';

export const WHATSAPP_QR_CHANNEL_SUBTYPE = 'whatsapp_qr';
export const WHATSAPP_QR_OUTGOING_URL =
  'https://customer.etisalna.com/outgoing.php';

/**
 * Returns true when an inbox is a WhatsApp QR inbox — i.e. a Channel::Api
 * inbox that was created through the WhatsApp QR flow.
 * Accepts both camelCase (composable/store) and snake_case (raw API) shapes.
 */
export const isWhatsappQrInbox = inbox => {
  if (!inbox) return false;
  const channelType = inbox.channelType || inbox.channel_type;
  if (channelType !== INBOX_TYPES.API) return false;
  const attrs =
    inbox.additionalAttributes || inbox.additional_attributes || {};
  return attrs.channelSubtype === WHATSAPP_QR_CHANNEL_SUBTYPE ||
    attrs.channel_subtype === WHATSAPP_QR_CHANNEL_SUBTYPE;
};

/**
 * Returns the display icon for an inbox, overriding the API cloud icon with
 * the WhatsApp icon for WhatsApp QR inboxes.
 */
export const getInboxDisplayIcon = (inbox, variant = 'fill') => {
  if (isWhatsappQrInbox(inbox)) {
    return getInboxIconByType(INBOX_TYPES.WHATSAPP, null, variant);
  }
  const channelType = inbox.channelType || inbox.channel_type;
  const medium = inbox.medium;
  return getInboxIconByType(channelType, medium, variant);
};
